// extracted by mini-css-extract-plugin
export default {"main":"notFound_main__ih6Kg"};